import React, { FC, useState } from "react";
import { hasPermission } from "../../../helpers/utils/AccessControlUtils";
import { useCheckUserIsManagerQuery, useGetOrderByOrderIdAndTypeQuery } from "../ordersApi";
import { Link, useParams } from "react-router-dom";
import { formatValueAsDate } from "../../../helpers/utils/DateUtils";
import { commonSortingList, getProductIcon } from "../../../helpers/utils/Utils";
import { useGetEnumsQuery } from "../../../app/globalApi";
import { AssignToSection } from "../modal/AssignToSection";
import TeamListModal from "../editor/Common/Modals/TeamListModal";
import AssignToForm from "../editor/Common/Modals/AssignToForm";
import AddFollowUpForProduct from "../modal/AddFollowUpForProduct";
import { ReadDiffViewerModal } from "../modal/ReactCommonDiffModal";

const ProductsDetail: FC = () => {

    const { orderId } = useParams();
    const isUserManager = useCheckUserIsManagerQuery(orderId)
    const [showAssignToModal, setShowAssignToModal] = useState(false);
    const [assignedTo, setAssignedTo] = useState<string | null>(() => null);
    const [showTeamListModal, setShowTeamListModal] = useState(false);
    const [productId, setProductId] = useState<string | null>(() => null);
    const [showTeamManagerModal, setShowTeamManagerModal] = useState(false);
    const [assignedTeam, setAssignedTeam] = useState<string | null>(() => null);
    const {
        data: orderData,
    } = useGetOrderByOrderIdAndTypeQuery({ orderId: orderId, orderType: 'OTHER' });
    const [curProduct, setCurProduct] = useState<any>({});
    const [showFollowUpModal, setShowFollowUpModal] = useState(false);

    const { data: enums } = useGetEnumsQuery("");
    const [showReadDiffViewer, setShowReadDiffViewer] = useState(false);
    const [productIdForResultHistory, setProductIdForResultHistory] = useState(null);


    function showEditor(type: any, productSchema: any) {
        if (!hasPermission(["CERT-V"])) {
            return;
        }

        if (type.includes("TAX_") === true && productSchema === "DEFAULT") {
            return "/orders/taxCertEditor/" + orderId;
        } else if (type.includes("TAX_") === true && productSchema === "NATIONAL") {
            return "/orders/national/taxCertEditor/" + orderId;
        } else if (type.includes("HOA_FULL") === true) {
            return "/orders/hoaFullEditor/" + orderId;
        } else if (type.includes("HOA_CONTACT") === true) {
            return "/orders/hoaContactEditor/" + orderId;
        }

    }

    const havePropertyResult = (orderData: any) => {
        const properties = orderData?.properties;
        let isNotEmpty = false;
        for (let property of properties) {
            if (property?.propertyResult === "" || property?.propertyResult === null) {
                isNotEmpty = true;
                return isNotEmpty;
            }

        }
        return isNotEmpty;
    }

    return (
        <>
            <div className="bg-text-1 shadow-[0_3px_10px_#0003] text-sm mt-3 rounded-md mb-2">
                <div className="flex justify-between items-center border-b bordder border-surface-7 p-2">
                    <h6 className={"font-semibold text-surface-0"}>Products
                        ({orderData && orderData?.error === undefined && orderData?.products?.length || 0})</h6>
                </div>
                {(orderData && orderData?.error === undefined) ? orderData?.products && commonSortingList(orderData?.products, ['type'], ['desc']).map((curProduct: any) => {
                    return (
                        <div className="card px-2 py-0.5">
                            <div className="bg-text-0 card-header p-2 border border-surface-5 rounded">
                                <div className="grid grid-cols-12 gap-8 items-center w-full">
                                    {/* Follow Up Icon */}
                                    {hasPermission(["PROFOLLUP-V"]) && (
                                        <div className="col-span-1 flex items-center">
                                            <div className="card_icons text-2xl"
                                                title={curProduct.followUpTypeDTO != null ? `${curProduct.followUpTypeDTO.name} : ${formatValueAsDate(curProduct.followUp.followUpAdded, "MM/DD/YY")} ${curProduct.followUp.followUpMessage}` : "Start Follow Up"}>
                                                <i
                                                    className={hasPermission(["PROFOLLUP-R", "PROFOLLUP-C"])
                                                        ? curProduct.followUpTypeDTO === null
                                                            ? "text-text-2 fa fa-tag mt-1"
                                                            : "fa fa-tag mt-1 cursor-pointer"
                                                        : "fa fa-tag mt-1"}
                                                    style={{ color: curProduct.followUpTypeDTO?.hexColor || "" }}
                                                    onClick={() => {
                                                        if (curProduct.followUpTypeDTO === null ? hasPermission(["PROFOLLUP-C"]) : hasPermission(["PROFOLLUP-R"])) {
                                                            setCurProduct(curProduct);
                                                            setShowFollowUpModal(true);
                                                        }
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    )}

                                    {/* Icon */}
                                    <div className="col-span-1 text-lg">
                                        <i className={getProductIcon(curProduct.type)} />
                                    </div>

                                    {/* Product Name */}
                                    <div className="col-span-2 text-[#2756B3] text-md ml-4">
                                        <Link
                                            to={showEditor(curProduct.type, curProduct.resultSchema) || "#"}
                                            style={orderData && havePropertyResult(orderData) ? { pointerEvents: "none", color: "gray" } : {}}
                                            className={hasPermission(["CERT-R"])
                                                ? curProduct.type.includes("TAX_") || curProduct.type.includes("HOA_")
                                                    ? "cursor editable"
                                                    : "unlink"
                                                : "unlink"}
                                        >
                                            {enums?.["ProductType"]?.find((curEnum:any) => curEnum.constant === curProduct.type)?.value}
                                        </Link>
                                    </div>

                                    {/* Manual/Auto Icon */}
                                    {hasPermission(["CERT-R"]) && (
                                        <div className="col-span-1 flex items-center">
                                            <i className={curProduct?.manualOverride ? "text-text-2 fa-robot fa-solid notClickable" : "fa-robot fa-solid notClickable"}
                                                title={curProduct?.manualOverride ? "Manual" : "Automated"} />
                                        </div>
                                    )}

                                    {/* Product Status */}
                                    {hasPermission(["CERT-R"]) && (
                                        <div className="col-span-2 flex items-center">
                                            <p className="mb-0 truncate">{curProduct.productStatus}</p>
                                        </div>
                                    )}

                                    {/* Assigned To */}
                                    {hasPermission(["CERT-R"]) && (
                                        <div className="col-span-2 flex items-center break-all">
                                            <span>{curProduct?.assignedTo || '-'}</span>
                                            {curProduct?.targetTeamName && <span className="ml-1">({curProduct.targetTeamName})</span>}
                                        </div>
                                    )}

                                    {/* Assign To Section */}
                                    {hasPermission(["CERT-R"]) && orderData?.active &&
                                        (curProduct.type.includes("TAX_") || curProduct.type.includes("HOA_")) && (
                                            <div className="col-span-2 flex items-center">
                                                <AssignToSection
                                                    isUserManager={isUserManager}
                                                    setShowAssignToModal={setShowAssignToModal}
                                                    assignedTo={curProduct?.assignedTo}
                                                    setAssignedTo={setAssignedTo}
                                                    assignedTeam={curProduct?.targetTeamId}
                                                    setAssignedTeam={setAssignedTeam}
                                                    productId={curProduct?.id}
                                                    setProductId={setProductId}
                                                    setShowTeamListModal={setShowTeamListModal}
                                                    setShowTeamManagerModal={setShowTeamManagerModal}
                                                />
                                            </div>
                                        )}

                                    {/* Timeline Icon */}
                                    {(curProduct.type.includes("TAX_") || curProduct.type.includes("HOA_")) &&
                                        hasPermission(["CERT-R"]) && (
                                            <div className="col-span-1 flex items-center">
                                                <i
                                                    className="fa fa-solid fa-timeline timeline-icon cursor-pointer"
                                                    onClick={() => {
                                                        setProductIdForResultHistory(curProduct.id);
                                                        setShowReadDiffViewer(true);
                                                    }}
                                                    title={`Click to compare ${enums?.["ProductType"]?.find((curEnum:any) => curEnum.constant === curProduct.type)?.value || ""}`}
                                                />
                                            </div>
                                        )}
                                </div>
                            </div>
                        </div>
                    )
                }) : <div />}

                {showAssignToModal &&
                    <AssignToForm show={showAssignToModal} setShow={setShowAssignToModal}
                        productId={productId}
                        tenant={orderData?.tenant}
                    />

                }
                {showTeamListModal && <TeamListModal
                    show={showTeamListModal}
                    setShow={setShowTeamListModal}
                    assignedToProps={assignedTeam}
                    productId={productId}
                    tenant={orderData?.tenant}
                />
                }
            </div>
            {
                showFollowUpModal && <AddFollowUpForProduct show={showFollowUpModal}
                    setShow={setShowFollowUpModal}
                    isHoa={false}
                    btnName={curProduct?.followUp?.followUpTypeId ? "Update" : "Add"}
                    currentProduct={curProduct}
                    orderId={orderId}
                />
            }
            {showReadDiffViewer &&
                <ReadDiffViewerModal show={showReadDiffViewer} setShow={setShowReadDiffViewer}
                    productId={productIdForResultHistory} />}
        </>
    )
}

export default ProductsDetail;